import { Box, Flex, Spinner, Text, useColorModeValue } from '@chakra-ui/react';
import { Vendor, vendorRepository } from 'api/vendorRepository';
import { useAuth } from 'contexts/authContext';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import VendorDetailPanels from './components/VendorDetailPanels';

export default function VendorDetail() {
  const location = useLocation();
  const { user, role } = useAuth();
  const [vendor, setVendor] = useState<Vendor | null>(null);
  const [loading, setLoading] = useState(true);

  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const infoBg = useColorModeValue('gray.50', 'navy.700');
  const textColor = useColorModeValue('gray.500', 'gray.300');

  const vendorIdFromState = (location.state as { vendorId?: string })?.vendorId;
  const effectiveVendorId = role === 'Vendor' && user?.vendorId
    ? user.vendorId
    : vendorIdFromState;

  useEffect(() => {
    async function fetchData() {
      try {
        if (!effectiveVendorId) {
          setLoading(false);
          return;
        }
        const vendorData = await vendorRepository.getVendorById(effectiveVendorId);
        setVendor(vendorData);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [effectiveVendorId]);

  if (loading) {
    return (
      <Flex justify="center" align="center" h="100vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  if (!vendor) {
    return (
      <Flex
        h="100vh"
        justify="center"
        align="center"
        px={4}
      >
        <Box
          borderWidth="1px"
          borderRadius="lg"
          p={8}
          // bg={cardBg}
          bg={infoBg}
          borderColor={borderColor}
          shadow="sm"
          maxW="520px"
          w="100%"
        >
          <Box
            p={6}
            borderWidth="0px"
            borderRadius="md"
            bg={infoBg}
            textAlign="center"
          >
            <Text fontSize="lg" fontWeight="bold" color={textColor}>
              Vendor not found. Please try again or contact the administrator.
            </Text>
          </Box>
        </Box>
      </Flex>
    );
  }
  return (
    <Box p={{ base: 4, md: 6 }} pt="90px" w="100%">
      <Flex justify="space-between" align="center" mb={6} wrap="wrap" gap={4}></Flex>
      <VendorDetailPanels vendor={vendor} setVendor={setVendor} fetchVendorProducts={() => { }} onProductUpdated={() => { }} />
    </Box>
  );
}